import React, { useState, useEffect } from "react";
import "./DashboardHOD.css";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { Switch } from "react-router";
import { Redirect } from "react-router-dom";
import NavBar from "../../PreComps/Includes/NavBar.jsx";
import PersonalInfo from "../PersonalInfo/PersonalInfo.jsx";
import Education from "../Education/Education";
import MonthlyReports from "../MonthlyReport/MonthlyReports";
import FamilyInfo from "../FamilyInfo/FamilyInfo.jsx";
import WorkExperience from "../WorkExperience/WorkExperience.jsx";
import LeaveApplicationEmp from "../LeaveApplication/LeaveApplicationEmp.jsx";
import NotFound404 from "../../PreComps/Includes/NotFound404";
import LeaveApplicationHODManage from "../LeaveApplicationHODManage/LeaveApplicationHOD";
import ViewReports from "../ViewReports/ViewReportsHOD";
import PerfEvalEmpHOD from "../PerfEval/PerfEvalEMPHOD.jsx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faUser,
  faFileAlt,
  faUniversity,
  faBriefcase,
  faMale,
} from "@fortawesome/free-solid-svg-icons";

export default function DashboardHOD(props) {
  const [redirect, setRedirect] = useState(true);
  const [checked, setChecked] = useState(true);

  const { data } = props;

  const handleChange = (checked) => {
    // console.log("switch");
    // var sidebarV = this.refs.sidebar;
    // var sidebarV = React.findDOMNode( this.refs.sidebar);
    // sidebarV.style.disply="none";

    if (checked === true) {
      // document.getElementById("sidebar").setAttribute("style", "display:none")
      document.getElementById("sidebar").setAttribute("class", "display-none");
    }
    // document.getElementById("sidebar").setAttribute("style", "display:block");
    else {
      document.getElementById("sidebar").setAttribute("class", "display-block");
    }
    setChecked(checked);
  };

  return (
    <Router>
      <div id="outer-main-div">
        <div id="outer-nav">
          {/* <NavBar loginInfo={this.data} /> */}
          <NavBar
            loginInfo={data}
            checked={checked}
            handleChange={handleChange}
            onLogout={props.onLogout}
          />
        </div>

        <div id="main-non-nav">
          <div id="sidebar">
            <div id="sidebar-top-content" />
            <div id="main-title" className="main-title-employee">
              <FontAwesomeIcon icon={faUsers} className="sidebar-icon" />
              Dashboard
            </div>
            <ul className="navbar-ul">
              <li>
                <Link to={"/hod/" + data["_id"] + "/personal-info"}>
                  <FontAwesomeIcon icon={faUser} className="sidebar-icon" />
                  Personal Information
                </Link>
              </li>
              <li>
                <Link to={"/hod/" + data["_id"] + "/education"}>
                  <FontAwesomeIcon
                    icon={faUniversity}
                    className="sidebar-icon"
                  />
                  Education
                </Link>
              </li>
              <li>
                <Link to={"/hod/" + data["_id"] + "/family-info"}>
                  <FontAwesomeIcon icon={faMale} className="sidebar-icon" />
                  Dependents
                </Link>
              </li>
              <li>
                <Link to={"/hod/" + data["_id"] + "/work-experience"}>
                  <FontAwesomeIcon
                    icon={faBriefcase}
                    className="sidebar-icon"
                  />
                  WorkExp
                </Link>
              </li>
              <li>
                <Link to={"/hod/" + data["_id"] + "/leave-application-emp"}>
                  <FontAwesomeIcon icon={faFileAlt} className="sidebar-icon" />
                  Submit Leave Application
                </Link>
              </li>
              <li>
                <Link to={"/hod/" + data["_id"] + "/monthly-reports"}>
                  <FontAwesomeIcon icon={faFileAlt} className="sidebar-icon" />
                  Submit Monthly Reports
                </Link>
              </li>
              <li>
                <Link to={"/hod/" + data["_id"] + "/leave-manage"}>
                  <FontAwesomeIcon icon={faFileAlt} className="sidebar-icon" />
                  Manage Leaves
                </Link>
              </li>

              <li>
                <Link to={"/hod/" + data["_id"] + "/view-reports"}>
                  <FontAwesomeIcon icon={faFileAlt} className="sidebar-icon" />
                  View Monthly Reports
                </Link>
              </li>
              <li>
                <Link to={"/hod/" + props.data["_id"] + "/PerfEval"}>
                  <FontAwesomeIcon icon={faFileAlt} className="sidebar-icon" />
                  Performance Evaluation
                </Link>
              </li>
            </ul>
          </div>

          <div id="main-area">
            <div id="sidebar-top-content" />
            {/* //table */}
            {/* <RoleHR/> */}
            <Switch>
              {/* <Route
                  path="/hod/:id/personal-info"
                  exact
                  component={PersonalInfoF}
                /> */}
              <Route
                exact
                path="/hod/:id/personal-info"
                render={(props) => <PersonalInfo data={data} back={false} />}
              />
              <Route
                exact
                path="/hod/:id/education"
                render={(props) => <Education data={data} back={false} />}
              />
              <Route
                exact
                path="/hod/:id/monthly-reports"
                render={(props) => <MonthlyReports data={data} back={false} />}
              />
              <Route
                exact
                path="/hod/:id/family-info"
                render={(props) => <FamilyInfo data={data} back={false} />}
              />
              <Route
                exact
                path="/hod/:id/work-experience"
                render={(props) => <WorkExperience data={data} back={false} />}
              />
              <Route
                exact
                path="/hod/:id/leave-application-emp"
                render={(props) => <LeaveApplicationEmp data={data} />}
              />
              <Route
                exact
                path="/hod/:id/leave-manage"
                render={(props) => <LeaveApplicationHODManage data={data} />}
              />
              <Route
                exact
                path="/hod/:id/view-reports"
                render={(props) => <ViewReports data={data} />}
              />
              />
              <Route
                exact
                path="/hod/:id/PerfEval"
                render={(props) => <PerfEvalEmpHOD data={props.data} />}
              />
              <Route render={() => <NotFound404 />} />
            </Switch>
          </div>
        </div>
      </div>
    </Router>
  );
}
